import { render, staticRenderFns } from "./hoc.vue?vue&type=template&id=4fe5e0fc&"
import script from "./hoc.vue?vue&type=script&lang=js&"
export * from "./hoc.vue?vue&type=script&lang=js&"
import style0 from "./hoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports